import { render } from "./ProductMain.vue?vue&type=template&id=54936a64&scoped=true"
import script from "./ProductMain.vue?vue&type=script&lang=js"
export * from "./ProductMain.vue?vue&type=script&lang=js"

import "./ProductMain.vue?vue&type=style&index=0&id=54936a64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54936a64"]])

export default __exports__